<template>
  <div class="ui form" id="main">
    <div v-if="umu_manager">
      <h3>
        Отправлено {{umu_agreed_times}} раз
      </h3>
    </div>
    <div v-if="department_manager">
      <h3>
        Отправлено {{department_agreed_times}} раз
      </h3>
    </div>
    <div class="inline fields">
      <div class="five wide field">
        <div class="ui right pointing large label">
          РАБОЧАЯ ПРОГРАММА
        </div>
        <input type="text" placeholder="Дисциплина" v-model="main_info.discipline" disabled="true">
      </div>
      <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] !== '05'">
        <div class="ui right pointing large label">
          Направление подготовки
        </div>
        <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
      </div>
      <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] === '05'">
        <div class="ui right pointing large label">
          Специальность
        </div>
        <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
      </div>
      <div class="four wide field">
        <div class="ui right pointing large label">
          Квалификация выпускника
        </div>
        <input type="text" placeholder="Квалификация" v-model="main_info.quality" disabled="true">
      </div>
    </div>
    <div class="inline fields">
      <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] !== '05'">
        <div class="ui right pointing large label">
          Профиль
        </div>
        <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
      </div>
      <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] === '05'">
        <div class="ui right pointing large label">
          Специализация
        </div>
        <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
      </div>
      <div class="two wide field">
        <div class="ui right pointing large label">
          Год набора
        </div>
        <input type="text" placeholder="Год набора" v-model="main_info.year" disabled="true">
      </div>
      <div class="three wide field">
        <div class="ui right pointing large label">
          Форма обучения
        </div>
        <input type="text" placeholder="Форма обучения" v-model="main_info.edu_form" disabled="true">
      </div>
    </div>
    <div class="ui equal width form">
      <div class="inline fields">
        <div class="three wide field">
          <div class="ui right pointing large label">
            Курс
          </div>
          <input type="text" placeholder="Курс" v-model="main_info.course" disabled="true">
        </div>
        <div class="three wide field">
          <div class="ui right pointing large label">
            Семестр
          </div>
          <input type="text" placeholder="Семестр" v-model="main_info.period" disabled="true">
        </div>
        <div class="three wide field" v-if="main_info.credit_mark.length">
          <div class="ui right pointing large label">
            Зачет с оценкой
          </div>
          <input type="text" placeholder="Зачет" v-model="main_info.credit_mark" disabled="true">
        </div>
        <div class="three wide field">
          <div class="ui right pointing large label">
            Трудоемкость
          </div>
          <input type="text" placeholder="Трудоемкость" v-model="main_info.load.hour" disabled="true">
        </div>
        <div class="three wide field">
          <div class="ui right pointing large label">
            ЗЕТ
          </div>
          <input type="text" placeholder="ЗЕТ" v-model="main_info.load.zet" disabled="true">
        </div>
      </div>
      <div class="inline fields">
        <div class="four wide field">
          <div class="ui right pointing large label">
            И.О.Фамилия
          </div>
          <input type="text" placeholder="И.О.Фамилия" v-model="initial" disabled="true">
        </div>
        <div class="four wide field">
          <div class="ui right pointing large label">
            Должность
          </div>
          <input type="text" placeholder="Должность" v-model="main_info.creator.position" disabled="true">
        </div>
        <div class="four wide field">
          <div class="ui right pointing large label">
            Ученая степень
          </div>
          <input type="text" placeholder="Ученая степень" v-model="main_info.creator.title" disabled="true">
        </div>
      </div>
    </div>
    <div class="two fields">
      <div class="six wide field">
        <label>Выпускающая кафедра</label>
        <div class="ui input">
          <input type="text" placeholder="Выпускающая кафедра" v-model="main_info.grad_dep" disabled="true">
        </div>
      </div>
      <div class="six wide field">
        <label>Заведующий выпускающей кафедры</label>
        <div class="ui input">
          <input type="text" placeholder="Заведующий выпускающей кафедры" v-model="provisor" disabled="true">
        </div>
      </div>
    </div>
    <div class="three fields">
      <div class="five wide field">
        <label>Факультет</label>
        <div class="ui input">
          <input type="text" placeholder="Факультет" v-model="main_info.facility" disabled="true">
        </div>
      </div>
      <div class="five wide field">
        <label>Обеспечивающая кафедра</label>
        <div class="ui input">
          <input type="text" placeholder="Обеспечивающая кафедра" v-model="main_info.department" disabled="true">
        </div>
      </div>
      <div class="five wide field">
        <label>
          Заведующий кафедрой
        </label>
        <div class="ui input">
          <input type="text" placeholder="Заведующий кафедрой" v-model="main_info.dep_manager" disabled="true">
        </div>
      </div>
    </div>
    <div class="two fields">
      <div class="four wide field">
        <label>Дата заседания кафедры</label>
        <div class="ui input">
          <input type="text" placeholder="Дата заседания кафедры" v-model="main_info.approval_date" disabled="true">
        </div>
      </div>
      <div class="two wide field">
        <label>Протокол №</label>
        <div class="ui input">
          <input type="text" placeholder="Протокол №" v-model="main_info.protocol_num" disabled="true">
        </div>
      </div>
    </div>
    <div><textarea rows="2" v-model="main_info.basis" disabled="true"></textarea></div>
    <div class="two fields">
      <div class="four wide field">
        <label>Дата утверждения приказа</label>
        <div class="ui input">
          <input type="text" placeholder="Дата утверждения приказа" v-model="main_info.basis_date" disabled="true">
        </div>
      </div>
      <div class="two wide field">
        <label>№ Приказа</label>
        <div class="ui input">
          <input type="text" placeholder="№ Приказа" v-model="main_info.basis_num" disabled="true">
        </div>
      </div>
    </div>
    <h3 class="ui dividing header" v-if="main_info.speciality_code.split('.')[1] !== '02'">1. ТИП ПРАКТИКИ И СПОСОБ ПРОВЕДЕНИЯ</h3>
    <div>
      <h4>1.1 Тип (форма проведения) практики</h4>
      <span v-html="practice_type.type"></span>
      <h4 v-if="main_info.speciality_code.split('.')[1] !== '02'">1.2 Способы проведения практики</h4>
      <span v-if="main_info.speciality_code.split('.')[1] !== '02'" v-html="practice_type.method"></span>
    </div>
    <h3 class="ui dividing header" v-if="main_info.speciality_code.split('.')[1] !== '02'">2. ЦЕЛИ  И ЗАДАЧИ  ПРАКТИКИ</h3>
    <span v-if="main_info.speciality_code.split('.')[1] !== '02'" v-html="text_info.purpose"></span>
    <h3 class="ui dividing header">3. КОМПЕТЕНЦИИ ОБУЧАЮЩЕГОСЯ, ФОРМИРУЕМЫЕ В РЕЗУЛЬТАТЕ ОСВОЕНИЯ ДИСЦИПЛИНЫ (МОДУЛЯ) И ИНДИКАТОРЫ ИХ ДОСТИЖЕНИЯ</h3>
    <div v-if="main_info.speciality_code.length !== 6 && main_info.speciality_code.length !== 7">
      <h4>3.1 Универсальные компетенции и индикаторы их достижения</h4>
      <table class="ui basic celled table">
        <thead>
        <tr class="active">
          <th width="20%"><div class="headTable">Категория (группа) универсальных компетенций</div></th>
          <th width="40%"><div class="headTable">Код и наименование универсальной компетенции</div></th>
          <th width="40%"><div class="headTable">Код и наименование индикатора достижения универсальной компетенции</div></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for = "comp in rpp_competitions.UK">
          <td>{{comp.info.cat}}</td>
          <td>
            {{ comp.info.code }} {{ comp.info.desc }}
          </td>
          <td v-html="comp.text"></td>
        </tr>
        </tbody>
      </table>
      <h4>3.2 Общепрофессиональные компетенции и индикаторы их достижения</h4>
      <table class="ui basic celled table" v-if="OPK.length">
        <thead>
        <tr class="active">
          <th width="20%"><div class="headTable">Категория (группа) общепрофессиональных компетенций</div></th>
          <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
          <th width="40%"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for = "comp in rpp_competitions.OPK_cat">
          <td>{{comp.info.cat}}</td>
          <td>
            {{ comp.info.code }} {{ comp.info.desc }}
          </td>
          <td v-html="comp.text"></td>
        </tr>
        </tbody>
      </table>
      <table class="ui basic celled table" v-if="!OPK.length">
        <thead>
        <tr class="active">
          <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
          <th width="60%"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for = "comp in rpp_competitions.OPK">
          <td>{{comp.name}}</td>
          <td v-html="comp.text"></td>
        </tr>
        </tbody>
      </table>
      <h4>3.3 Профессиональные компетенции и индикаторы их достижения</h4>
      <table class="ui basic celled table">
        <thead>
        <tr class="active">
          <th width="40%"><div class="headTable">Код и наименование профессиональной компетенции</div></th>
          <th width="60%"><div class="headTable">Код и наименование индикатора достижения профессиональной компетенции</div></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for = "comp in rpp_competitions.PK">
          <td>{{comp.name}}</td>
          <td v-html="comp.text"></td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <h5 class="ui dividing header">Уметь </h5>
      <span v-html="rpp_competitions.able"></span>
      <h5 class="ui dividing header">Знать </h5>
      <span v-html="rpp_competitions.know"></span>
      <h5 v-if="main_info.speciality_code.split('.')[1] !== '02'" class="ui dividing header">Владеть </h5>
      <h5 v-else class="ui dividing header">Иметь практическое применение </h5>
      <span v-html="rpp_competitions.own"></span>
    </div>
    <h3 class="ui dividing header">4. МЕСТО ПРАКТИКИ В СТРУКТУРЕ ОБРАЗОВАТЕЛЬНОЙ ПРОГРАММЫ </h3>
    <span v-html="text_info.place"></span>
    <h3 class="ui dividing header">5. МЕСТО И ВРЕМЯ ПРОВЕДЕНИЯ  ПРАКТИКИ </h3>
    <span v-html="text_info.time"></span>
    <h3 class="ui dividing header">6. ОБЪЕМ ПРАКТИКИ В ЗАЧЕТНЫХ ЕДИНИЦАХ И ЕЕ ПРОДОЛЖИТЕЛЬНОСТЬ В НЕДЕЛЯХ</h3>
    <span v-html="text_info.size"></span>
    <h3 class="ui dividing header">7. СТРУКТУРА И СОДЕРЖАНИЕ ПРАКТИКИ</h3>
    <table class="ui basic celled table">
      <thead>
      <tr class="active">
        <th width="5%"><div class="headTable">№ п/п</div></th>
        <th width="30%"><div class="headTable">Разделы (этапы) практики </div></th>
        <th width="50%"><div class="headTable">Содержание раздела (этапа) практики</div></th>
        <th width="5%"><div class="headTable">Трудоемкость (в академических часах)</div></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for = "work in structure">
        <td>{{structure.indexOf(work) + 1}}</td>
        <td>{{ work.part }}</td>
        <td v-html="work.content"></td>
        <td>{{ work.time }}</td>
      </tr>
      <tr>
        <td></td>
        <td colspan="2">Итого</td>
        <td colspan="2">{{needTime}} ({{main_info.load.hour}})</td>
      </tr>
      </tbody>
    </table>
    <h3 class="ui dividing header">8. ОБРАЗОВАТЕЛЬНЫЕ, НАУЧНО-ИССЛЕДОВАТЕЛЬСКИЕ И НАУЧНО-ПРОИЗВОДСТВЕННЫЕ ТЕХНОЛОГИИ, ИСПОЛЬЗУЕМЫЕ НА ПРАКТИКЕ</h3>
    <span v-html="text_info.technology"></span>
    <h3 class="ui dividing header">9. ФОРМА ОТЧЕТНОСТИ ПО ПРАКТИКЕ</h3>
    <span v-html="text_info.report_text"></span>
    <div v-if="main_info.speciality_code.length !== 6 && main_info.speciality_code.length !== 7">
      <h3 class="ui dividing header">10. ОЦЕНОЧНЫЕ СРЕДСТВА ДЛЯ ПРОВЕДЕНИЯ ПРОМЕЖУТОЧНОЙ АТТЕСТАЦИИ ПО ПРАКТИКЕ</h3>
      <vue-editor v-model="text_info.eval_tool" :editor-toolbar="customToolbar"/>
    </div>
    <h3 class="ui dividing header">11. УЧЕБНО-МЕТОДИЧЕСКИЕ МАТЕРИАЛЫ ПО ПРАКТИКЕ</h3>
    <div>
      <h4>11.1. Литература</h4>
      <span v-html="text_info.literature"></span>
      <h4>11.2. Программное обеспечение и Интернет-ресурсы</h4>
      <table class="ui basic celled table">
        <thead>
        <tr class="active">
          <th width="20%"><div class="headTable">Наименование</div></th>
          <th width="40%"><div class="headTable">Описание</div></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for = "soft in software">
          <td>
            {{soft.info.name}}
          </td>
          <td>
            {{ soft.info.license }}
          </td>
        </tr>
        <tr v-for = "res in resources">
          <td>{{res.name}}</td>
          <td>{{res.desc}}</td>
        </tr>
        </tbody>
      </table>
      <h4>11.3. Профессиональные базы данных и информационные справочные системы</h4>
      <table class="ui basic celled table">
        <thead>
        <tr class="active">
          <th width="20%"><div class="headTable">Наименование</div></th>
          <th width="40%"><div class="headTable">Описание</div></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for = "db in data_bases">
          <td>{{db.name}}</td>
          <td>{{db.desc}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <h3 class="ui dividing header">12. ИНФОРМАЦИОННЫЕ ТЕХНОЛОГИИ, ИСПОЛЬЗУЕМЫЕ ДЛЯ ПРОВЕДЕНИЯ  ПРАКТИКИ</h3>
    <span v-html="text_info.inform_tech"></span>
    <h3 class="ui dividing header">13. МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ  ПРАКТИКИ </h3>
    <span v-html="text_info.mto"></span>
    <div v-if="umu_manager">
      <button class="ui button negative" v-on:click="denyRPPUMU(rpp_id, umu_agreed_times, umu_comment)">
        Отклонить
      </button>
      <button class="ui right floated button positive" v-on:click="agreedRPPUMU(rpp_id)">
        Согласовать
      </button>
    </div>
    <div v-if="department_manager">
      <button class="ui button negative" v-on:click="denyRPPDepartment(rpp_id, department_agreed_times, department_comment)">
        Отклонить
      </button>
      <button class="ui right floated button positive" v-on:click="agreedRPPDepartment(rpp_id)">
        Согласовать
      </button>
    </div>
    <div class="ui modal" id="deny_umu_modal">
      <div class="ui header">Отклонить?</div>
      <div class="content">
        <div class="ui form">
          <div class="field">
            <label>Оставить отзыв (опционально)</label>
            <textarea v-model="deny_text"></textarea>
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="ui gray deny button">
          Закрыть
        </div>
        <div class="ui positive inverted right labeled icon button">
          Подтвердить
          <i class="checkmark icon"></i>
        </div>
      </div>
    </div>
    <div class="ui modal" id="error_umu_modal">
      <div class="ui header">Произошла ошибка</div>
      <div class="content">
        <div class="ui form">
          <div class="field">
            <label v-model="error_message_text"></label>
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="ui gray deny button">
          Закрыть
        </div>
        <div class="ui positive inverted right labeled icon button">
          Подтвердить
          <i class="checkmark icon"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import competitionsMixin from "../mixins/competitionsMixin";

export default {
  name: "show_rpp",
  mixins: [competitionsMixin],
  data: () => ({
    rpp_id: 0,
    curriculum_id: 0,
    discipline_id: 0,
    select_options: { departments: [], software: []},
    rpp: {edu_prog: 0, year: 0, edu_prof: 0, curriculum: 0, discipline: 0, rpp_sample: 0},
    main_info: {
      discipline: "",
      speciality: "",
      speciality_code: "01.03.02",
      profile: "",
      quality: "",
      year: "",
      edu_form: "",
      course: [],
      period: [],
      credit_mark: [],
      load: {hour: 0.0, zet: 0.0},
      creator: {fio: "Фасахов Тимур Ирикович", position: "", title: ""},
      facility: "",
      department: "",
      dep_manager: "",
      grad_dep: "",
      approval_date: "",
      protocol_num: "",
      provisor: "",
      basis: "Рабочая программа составлена на основании Федерального государственного образовательного стандарта ВО для ",
      basis_date: "",
      basis_num: "",
    },
    overload: [],
    software: [],
    data_bases: [],
    resources: [],
    structure: [{
      part: "",
      content: "",
      time: 0,
    }],
    text_info: {purpose: "", time: "", place: "", technology: "", eval_tool: "", literature: "", mto: "", size: "", report_text: "", inform_tech: ""},
    rpp_competitions: { UK: [], OPK_cat: [], OPK: [], PK: []},
    practice_type: {type: "", method: ""},
    umu_agreed: null,
    deny_text: "",
    umu_agreed_times: 1,
    umu_manager: false,
    umu_comment: "",
    department_agreed_times: 1,
    department_manager: false,
    department_comment: "",
    error_message_text: "",
    customToolbar: [
      [{ header: [false, 1, 2, 3, 4] }],

      [{ size: ["small", false, "large"] }],

      ["bold", "italic", "underline"],

      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" }
      ],

      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],

      [{ script: "sub" }, { script: "super" }],

      [{ indent: "-1" }, { indent: "+1" }],

      ["link"],

      ["clean"]
    ],
    customContentToolbar: [

      ["bold", "italic", "underline"],

      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" }
      ],

      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],

      [{ script: "sub" }, { script: "super" }],

      [{ indent: "-1" }, { indent: "+1" }],

      ["link"],

      ["clean"]
    ],
  }),

  computed: {
    initial: function (){
      let initial = ""
      initial += this.main_info.creator.fio.split(' ')[1][0];
      initial +="."
      initial += this.main_info.creator.fio.split(' ')[2][0];
      initial +="."
      initial += this.main_info.creator.fio.split(' ')[0];

      return initial;
    },
    TotalLoad: function (){
      let period = [...new Set(this.overload.map(item => item.period))];
      let load = [];
      period.forEach(per => {
        load.push({
          key: per,
          value: this.overload.filter(item => item.period === per)
        })
      });
      return load;
    },
    provisor: function (){
      this.select_options.departments.forEach(head => {
        if (head.name === this.main_info.grad_dep){
          this.main_info.provisor = head.head;
        }
      })
      return this.main_info.provisor
    },
    UK: function (){
      return this.competitions[this.main_info.speciality_code].UK
    },
    OPK: function (){
      return this.competitions[this.main_info.speciality_code].OPK
    },
    needTime: function (){
      let time = 0.0
      this.structure.forEach(theme => {
        time += parseFloat(theme.time)
      })
      return time.toFixed(1)
    },
  },

  methods: {
    getRPP(id) {
      axios({
        method: 'get',
        url: `/programms/get_rpp/${id}`,
      }).then((response) => {
        this.text_info.purpose = response.data.rpp.purpose_old;
        this.text_info.time = response.data.rpp.practice_time_old;
        this.text_info.place = response.data.rpp.practice_place_old;
        this.text_info.technology = response.data.rpp.edu_tech_old;
        this.text_info.eval_tool = response.data.rpp.eval_tool_old;
        this.text_info.literature = response.data.rpp.literature_old;
        this.text_info.report_text = response.data.rpp.report_text_old;
        this.text_info.size = response.data.rpp.practice_size_old;
        this.text_info.inform_tech = response.data.rpp.inform_tech_old;
        this.text_info.mto = response.data.rpp.structure_text_old;
        this.software = response.data.rpp.software;
        this.resources = response.data.rpp.resources;
        this.data_bases = response.data.rpp.data_bases;
        this.structure = response.data.rpp.structure;
        this.practice_type = response.data.rpp.practice_type;
        this.rpp_competitions = response.data.rpp.competition;
        this.main_info = response.data.rpp.main_info;
        this.curriculum_id = response.data.rpp.curriculum_id;
        this.discipline_id = response.data.rpp.discipline_id;
        this.umu_agreed = response.data.rpp.umu_agreed;
        this.department_agreed = response.data.rpp.department_agreed;
        this.umu_agreed_times = response.data.rpp.umu_agreed_times;
        this.umu_comment = response.data.rpp.umu_comment;
        this.department_agreed_times = response.data.rpp.department_agreed_times;
        this.department_comment = response.data.rpp.department_comment;
        this.getGraduatedDep(this.curriculum_id)
        this.getOverload(this.curriculum_id, this.discipline_id)
      }).catch((error) => {
        return error;
      });
    },
    getOverload(curriculum_id, discipline_id) {
      axios({
        method: 'get',
        url: `/programms/get_overload/${curriculum_id}/${discipline_id}`,
      }).then((response) => {
        this.overload = response.data.overload;
        this.getTimes()
      }).catch((error) => {
        return error;
      });
    },
    denyRPPUMU(id, times, text){
      this.deny_text = text;
      $('#deny_umu_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpp/' + id,
            data: {
              data: {
                umu_agreed: false,
                umu_comment: this.deny_text,
                umu_agreed_times: times + 1,
                considered: false,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204){
              this.nextToAgreed()
            } else {
              $('#error_umu_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_umu_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPPUMU(id){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpp/' + id,
        data: {
          data: {
            umu_agreed: true,
          }
        }
      }).then((response) => {
        if(response.status == 200 || response.status == 204){
          this.nextToAgreed()
        } else {
          $('#error_umu_modal').modal({
            closable: false,
            autofocus: false,
            onDeny: () => {
            },
            onApprove: () => {
            }
          }).modal('show');
        }
      }).catch((error) => {
        this.error_message_text = error.response.data,
            $('#error_umu_modal').modal({
              closable: false,
              autofocus: false,
              onDeny: () => {
              },
              onApprove: () => {
              }
            }).modal('show');
        return error;
      });
    },
    denyRPPDepartment(id, times, text){
      this.deny_text = text;
      $('#deny_umu_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpp/' + id,
            data: {
              data: {
                department_agreed: false,
                department_comment: this.deny_text,
                department_agreed_times: times + 1,
                considered: false,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204){
              location.assign('/programms/rpd')
            } else {
              $('#error_umu_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_umu_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPPDepartment(id){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpp/' + id,
        data: {
          data: {
            department_agreed: true,
          }
        }
      }).then((response) => {
        if(response.status == 200 || response.status == 204){
          location.assign('/programms/rpd')
        } else {
          $('#error_umu_modal').modal({
            closable: false,
            autofocus: false,
            onDeny: () => {
            },
            onApprove: () => {
            }
          }).modal('show');
        }
      }).catch((error) => {
        this.error_message_text = error.response.data,
            $('#error_umu_modal').modal({
              closable: false,
              autofocus: false,
              onDeny: () => {
              },
              onApprove: () => {
              }
            }).modal('show');
        return error;
      });
    },
    umuManager(){
      axios({
        method: 'get',
        url: `/programms/umu_manager`,
      }).then((response) => {
        this.umu_manager = response.data.umu;
      }).catch((error) => {
        return error;
      });
    },
    departmentManager(){
      axios({
        method: 'get',
        url: `/programms/department_manager`,
      }).then((response) => {
        this.department_manager = response.data.umu;
      }).catch((error) => {
        return error;
      });
    },
    nextToAgreed(){
      axios({
        method: 'get',
        url: `/programms/first_to_agreed_rpp`,
      }).then((response) => {
        location.assign(`/programms/rpp/${response.data.id}`)
      }).catch((error) => {
        return error;
      });
    },
  },
  mounted() {
    this.rpp_id = window.location.pathname.split('/')[3]
    this.getRPP(this.rpp_id)
    this.umuManager()
    this.departmentManager()
  }
}
</script>

<style scoped>

</style>